import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";
import Home from "./pages/Home";
import { Modal } from "antd";
import axios from "axios";

const ReachableContext = React.createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {() => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyToken = queryParams.get("loginToken") || queryParams.get("verifyToken");
  const [token, setToken] = useState(
    verifyToken
      ? null
      : localStorage.getItem("servicePaymentToken")
  );
  const history = useHistory();
  const location = useLocation();
  // Get current route from URL path
  const getCurrentRoute = () => {
    const path = location.pathname;
    if (path.includes("/data")) return "data";
    if (path.includes("/game")) return "game";
    if (path.includes("/cardPhone")) return "card";
    if (path.includes("/history")) return "history";
    return "phone";
  };

  const decodeToken = async () => {
    try {
      if (
        verifyToken
      ) {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/v1/auth/login-mbvbank`, {
          VerifyToken: verifyToken,
          TypeService: "topupmobile"
        });
        console.log(res, 'res');
        localStorage.setItem("servicePaymentToken", res.data.data.accesstoken);
        const userInfo = res.data.data.userinfo;
        if (userInfo?.phone) {
          userInfo.phone = userInfo.phone.replace(/^84/, "0");
        }
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        setToken(res.data.data.accesstoken);
      } 
    } catch (error) {
      modal.error(config);
    }
  };

  // Update active tab when route changes
  useEffect(() => {
    const route = getCurrentRoute();
    if (window.setActiveTabForHome) {
      window.setActiveTabForHome(route);
    }
    decodeToken();
  }, [location.pathname]);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to="/phone" />
        
        {/* All routes render Home with route parameter */}
        <Route
          path="/phone"
          render={(props) => <Home {...props} token={token} route="phone" />}
        />
        <Route
          path="/data"
          render={(props) => <Home {...props} token={token} route="data" />}
        />
        <Route
          path="/game"
          render={(props) => <Home {...props} token={token} route="game" />}
        />
        <Route
          path="/cardPhone"
          render={(props) => <Home {...props} token={token} route="card" />}
        />
        <Route
          path="/history"
          render={(props) => <Home {...props} token={token} route="history" />}
        />
        {/* Default route */}
        <Redirect to="/phone" />
      </Switch>
      {contextHolder}
    </>
  );
};

export default App;